// @ts-ignore
import { checkIsStringEmpty as _checkIsStringEmpty } from "@my-scoot/exly-react-component-lib/build/esm/features/Common/modules/DataTypes/utils/strings";
import type { checkIsStringEmpty as checkIsStringEmptyType } from "@my-scoot/exly-react-component-lib/build/types/features/Common/modules/DataTypes/utils/strings";

export const checkIsStringEmpty: typeof checkIsStringEmptyType =
  _checkIsStringEmpty;
